import { render } from "./Chat.vue?vue&type=template&id=48be9ccc&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=48be9ccc&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48be9ccc"],['__file',"src/views/message/Chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48be9ccc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48be9ccc', __exports__)) {
    console.log('reload')
    api.reload('48be9ccc', __exports__)
  }
  
  module.hot.accept("./Chat.vue?vue&type=template&id=48be9ccc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('48be9ccc', render)
  })

}


export default __exports__